import R from 'ramda'

import {
  ACTIONS,
  PAGES,
  APP_TYPE
} from '../constants'

import {
  defaultInstitutionPageState,
  defaultPageState
} from '../store'

import {
  isAuthAdmin,
  isLicenseAdmin,
  isInstAdmin
} from '_utils'
import { isLicenseViewer } from '../utils'

const actionIs = R.pathEq(['action', 'type'])

const progPath = ['authStatus', 'request', 'progress']
const reqPath = ['authStatus', 'request']

const getErrorFromAction = (action) => R.pathOr(
  R.pathOr('unknown error',
    ['error', 'message'], action
  ),
  ['body', 'error'], action
)

const abortIfXhrExists = R.cond([
  [R.compose(R.not, R.isNil, R.prop('xhr')), ({xhr}) => (console.log('xhr', xhr, xhr.abort()))],
  [R.T, (req) => console.log('xhr is null')]
])

const userLoginRequest = ({state, action}) => {
  const oldReq = R.path(reqPath, state)
  abortIfXhrExists(oldReq)
  const request = R.merge(
    oldReq,
    {
      url: R.propOr('unknown', 'url', action),
      isLoading: true,
      progress: 0,
      xhr: R.propOr(null, 'xhr', action),
      error: null
    }
  )
  return R.assocPath(reqPath, request, state)
}

const bodyIdIsString = R.compose(R.is(String), R.path(['body', '_id']))
const getUserIfIdExists = R.cond([
  [bodyIdIsString, (action) => R.propOr(null, 'body', action)],
  [R.T, (action) => null]
])

const userLoginSuccess = ({state, action}) => {
  // always set user to null if the path doesn't have an _id
  // const user = R.propOr(null, 'body', action)
  const user = getUserIfIdExists(action)
  const request = R.path(reqPath, state)
  const authStatus = {
    user,
    request: R.merge(request, {
      isLoading: false,
      error: null,
      progress: 0
    })
  }
  return R.assoc('authStatus', authStatus, state)
}

const userLoginFailure = ({state, action}) => {
  const error = getErrorFromAction(action)
  console.log('userLoginFailure', error)
  const request = R.merge(
    R.path(reqPath, state),
    {
      isLoading: false,
      progress: 0,
      error
    }
  )
  return R.assocPath(reqPath, request, state)
}

const userLoginProgress = ({state, action}) => {
  const progress = R.pathOr(0, ['event', 'percent'], action)
  return R.assocPath(progPath, progress, state)
}

const fetchMeSuccess = ({state, action}) => {
  // we set the auth user in the case where the user comes to the site
  // already with token
  const newState = userLoginSuccess({state, action})
  // now we need to set up the main App and page structure based on user
  // being admin or not
  const user = R.path(['authStatus', 'user'], newState)
  const amAdmin = isAuthAdmin(user) || isLicenseAdmin(user) || isLicenseViewer(user);
  const amInstAdmin = isInstAdmin(user)
  const pages = amAdmin
    ? {
      [PAGES.USERS]: defaultPageState,
      [PAGES.INSTITUTIONS]: defaultPageState,
      [PAGES.RESELLERS]: defaultPageState,
      [PAGES.SERIALS]: defaultPageState,
      [PAGES.LICENSES]: defaultPageState
    }
    : amInstAdmin
      ? user.institutions.reduce(
        (acc, inst) => R.assoc(inst._id, R.merge(defaultInstitutionPageState, {institution: inst}), acc)
        , {})
      : {}

  const defaultPage = amAdmin
    ? PAGES.USERS
    : amInstAdmin
      ? R.path(['institutions', 0, '_id'], user)
      : ''

  const type = amAdmin
    ? APP_TYPE.FULL
    : amInstAdmin
      ? APP_TYPE.THIRD_PARTY
      : APP_TYPE.BLANK

  return R.compose(
    R.assoc('type', type),
    R.assoc('defaultPage', defaultPage),
    R.assoc('pages', pages)
  )(newState)
}

const clearAuthError = ({state, action}) => {
  const request = R.merge(
    R.path(reqPath, state),
    {
      error: null
    }
  )
  return R.assocPath(reqPath, request, state)
}

const reducerList = [
  [actionIs(ACTIONS.AUTH_STATUS.CLEAR_ERROR), clearAuthError], // just reuse the same login functions

  [actionIs(ACTIONS.AUTH_STATUS.FETCH_ME.FAILURE), userLoginFailure], // just reuse the same login functions
  [actionIs(ACTIONS.AUTH_STATUS.FETCH_ME.SUCCESS), fetchMeSuccess],
  [actionIs(ACTIONS.AUTH_STATUS.FETCH_ME.PROGRESS), userLoginProgress],
  [actionIs(ACTIONS.AUTH_STATUS.FETCH_ME.REQUEST), userLoginRequest],

  [actionIs(ACTIONS.AUTH_STATUS.LOGOUT.FAILURE), userLoginFailure], // just reuse the same login functions
  [actionIs(ACTIONS.AUTH_STATUS.LOGOUT.SUCCESS), userLoginSuccess],
  [actionIs(ACTIONS.AUTH_STATUS.LOGOUT.PROGRESS), userLoginProgress],
  [actionIs(ACTIONS.AUTH_STATUS.LOGOUT.REQUEST), userLoginRequest],

  [actionIs(ACTIONS.AUTH_STATUS.LOGIN.FAILURE), userLoginFailure],
  [actionIs(ACTIONS.AUTH_STATUS.LOGIN.SUCCESS), fetchMeSuccess],
  [actionIs(ACTIONS.AUTH_STATUS.LOGIN.PROGRESS), userLoginProgress],
  [actionIs(ACTIONS.AUTH_STATUS.LOGIN.REQUEST), userLoginRequest]
]
export default reducerList



// WEBPACK FOOTER //
// ./webAdmin/reducers/access.js